export { default } from './MaterialsList'
